<!-- reporte-deuda.component.html -->
<div class="reporte-container" *appRole="['PeriodosContrato.ReporteDeudaPeriodoContrato']">
  <mat-card>
   <mat-card-header>
      <mat-card-title>
        <mat-icon>assessment</mat-icon>
        Reporte de Estado de Deudas
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-lg-4">
            <app-buscar-contrato (eventEntity)="onContratoSelected($event)"></app-buscar-contrato>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>date_range</mat-icon>
              <mat-label>Mes Desde</mat-label>
              <mat-select formControlName="periodoMesDesde">
                <mat-option [value]="1">Enero</mat-option>
                <mat-option [value]="2">Febrero</mat-option>
                <mat-option [value]="3">Marzo</mat-option>
                <mat-option [value]="4">Abril</mat-option>
                <mat-option [value]="5">Mayo</mat-option>
                <mat-option [value]="6">Junio</mat-option>
                <mat-option [value]="7">Julio</mat-option>
                <mat-option [value]="8">Agosto</mat-option>
                <mat-option [value]="9">Septiembre</mat-option>
                <mat-option [value]="10">Octubre</mat-option>
                <mat-option [value]="11">Noviembre</mat-option>
                <mat-option [value]="12">Diciembre</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>event</mat-icon>
              <mat-label>Año Desde</mat-label>
              <input type="number" matInput formControlName="periodoAnioDesde" [min]="2020" [max]="2030">
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>date_range</mat-icon>
              <mat-label>Mes Hasta</mat-label>
              <mat-select formControlName="periodoMesHasta">
                <mat-option [value]="1">Enero</mat-option>
                <mat-option [value]="2">Febrero</mat-option>
                <mat-option [value]="3">Marzo</mat-option>
                <mat-option [value]="4">Abril</mat-option>
                <mat-option [value]="5">Mayo</mat-option>
                <mat-option [value]="6">Junio</mat-option>
                <mat-option [value]="7">Julio</mat-option>
                <mat-option [value]="8">Agosto</mat-option>
                <mat-option [value]="9">Septiembre</mat-option>
                <mat-option [value]="10">Octubre</mat-option>
                <mat-option [value]="11">Noviembre</mat-option>
                <mat-option [value]="12">Diciembre</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-2">
            <mat-form-field class="example-full-width">
              <mat-icon matPrefix>event</mat-icon>
              <mat-label>Año Hasta</mat-label>
              <input type="number" matInput formControlName="periodoAnioHasta" [min]="2020" [max]="2030">
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <mat-checkbox formControlName="soloContratosActivos" color="primary" [disabled]="true">
              Solo contratos activos
            </mat-checkbox>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <button mat-stroked-button color="primary" (click)="generarReporte()">
              <mat-icon>search</mat-icon>
              Generar Reporte</button>&nbsp; &nbsp;
            <button mat-stroked-button color="primary" (click)="limpiarFiltros()">
              <mat-icon>clear_all</mat-icon>
              Limpiar Filtros</button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Spinner -->
  <ngx-spinner [zIndex]="100" name="spReporteDeuda" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
    type="ball-atom" [fullScreen]="false">
  </ngx-spinner>

  <!-- Contenido principal con tabs -->
  <div class="content-section" *ngIf="reporteData">
    <mat-tab-group [(selectedIndex)]="selectedTab" class="custom-tabs">

      <!-- Tab: Gráficos y Resumen -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">pie_chart</mat-icon>
          Gráficos y Resumen
        </ng-template>

        <div class="tab-content">
          <!-- Cards de resumen -->
          <div class="summary-cards">
            <mat-card class="summary-card inquilinos-card">
              <mat-card-header>
                <mat-icon mat-card-avatar color="primary">person</mat-icon>
                <mat-card-title>Deuda de Inquilinos</mat-card-title>
                <mat-card-subtitle>Estado de pagos</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <div class="summary-stats">
                  <div class="stat-item">
                    <span class="stat-label">Total:</span>
                    <span class="stat-value">{{formatearMoneda(reporteData.resumenInquilinos.montoTotal)}}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Pagado:</span>
                    <span class="stat-value paid">{{formatearMoneda(reporteData.resumenInquilinos.montoPagado)}}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Adeudado:</span>
                    <span
                      class="stat-value debt">{{formatearMoneda(reporteData.resumenInquilinos.montoAdeudado)}}</span>
                  </div>
                  <div class="stat-item highlight">
                    <span class="stat-label">% Adeudado:</span>
                    <span
                      class="stat-value debt">{{formatearPorcentaje(reporteData.resumenInquilinos.porcentajeAdeudado)}}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="summary-card propietarios-card">
              <mat-card-header>
                <mat-icon mat-card-avatar color="accent">home</mat-icon>
                <mat-card-title>Deuda a Propietarios</mat-card-title>
                <mat-card-subtitle>Estado de liquidaciones</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <div class="summary-stats">
                  <div class="stat-item">
                    <span class="stat-label">Total:</span>
                    <span class="stat-value">{{formatearMoneda(reporteData.resumenPropietarios.montoTotal)}}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Liquidado:</span>
                    <span
                      class="stat-value liquidated">{{formatearMoneda(reporteData.resumenPropietarios.montoPagado)}}</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-label">Por Liquidar:</span>
                    <span
                      class="stat-value pending">{{formatearMoneda(reporteData.resumenPropietarios.montoAdeudado)}}</span>
                  </div>
                  <div class="stat-item highlight">
                    <span class="stat-label">% Por Liquidar:</span>
                    <span
                      class="stat-value pending">{{formatearPorcentaje(reporteData.resumenPropietarios.porcentajeAdeudado)}}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <!-- Gráficos -->
          <div class="charts-section">
            <div class="charts-grid">
              <!-- Gráfico de torta - Inquilinos -->
              <mat-card class="chart-card">
                <mat-card-header>
                  <mat-icon mat-card-avatar>donut_large</mat-icon>
                  <mat-card-title>Deuda Inquilinos (%)</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="chart-container">
                    <canvas baseChart [datasets]="pieChartInquilinosData.datasets" [labels]="pieChartInquilinosLabels"
                      [options]="pieChartOptions!" [plugins]="pieChartPlugins" [legend]="pieChartLegend"
                      [chartType]="pieChartType">
                    </canvas>
                  </div>
                </mat-card-content>
              </mat-card>

              <!-- Gráfico de torta - Propietarios -->
              <mat-card class="chart-card">
                <mat-card-header>
                  <mat-icon mat-card-avatar>donut_small</mat-icon>
                  <mat-card-title>Deuda Propietarios (%)</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="chart-container">
                    <canvas baseChart [datasets]="pieChartPropietariosData.datasets"
                      [labels]="pieChartPropietariosLabels" [options]="pieChartOptions!" [plugins]="pieChartPlugins"
                      [legend]="pieChartLegend" [chartType]="pieChartType">
                    </canvas>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Tab: Detalle por Contrato -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">list</mat-icon>
          Detalle por Contrato
        </ng-template>

        <div class="tab-content">
          <mat-card class="table-card">
            <mat-card-header>
              <mat-icon mat-card-avatar>view_list</mat-icon>
              <mat-card-title>Detalle por Contrato</mat-card-title>
              <mat-card-subtitle>{{dataSource.data.length}} contratos encontrados</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="table-container">
                <table mat-table [dataSource]="dataSource" matSort class="custom-table">

                  <!-- Columna Contrato -->
                  <ng-container matColumnDef="numeroContrato">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-icon>assignment</mat-icon>
                      Contrato
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="contract-info">
                        <span class="contract-number">{{element.numeroContrato}}</span>
                        <span class="contract-status" [ngClass]="getClassEstadoContrato(element.contratoActivo)">
                          {{getEstadoContrato(element.contratoActivo)}}
                        </span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Columna Propiedad -->
                  <ng-container matColumnDef="propiedad">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-icon>home</mat-icon>
                      Propiedad
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.propiedad}}</td>
                  </ng-container>

                  <!-- Columna Total Períodos -->
                  <ng-container matColumnDef="totalPeriodos">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-icon>calendar_today</mat-icon>
                      Períodos
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <span class="period-badge">{{element.totalPeriodos}}</span>
                      <div class="period-amount">{{formatearMoneda(element.montoTotalContrato)}}</div>
                    </td>
                  </ng-container>

                  <!-- Columna Deuda Inquilino -->
                  <ng-container matColumnDef="deudaInquilino">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-icon>account_balance_wallet</mat-icon>
                      Deuda Inquilino
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="debt-info">
                        <span class="debt-amount debt">{{formatearMoneda(element.deudaInquilino)}}</span>
                        <span class="debt-periods">{{element.totalPeriodos - element.periodosPagadosInquilino}}
                          períodos</span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Columna % Pagado Inquilino -->
                  <ng-container matColumnDef="porcentajePagadoInquilino">
                    <th mat-header-cell *matHeaderCellDef>
                      % Pagado Inquilino
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="progress-container">
                        <mat-progress-bar mode="determinate" [value]="element.porcentajePagadoInquilino"
                          color="primary">
                        </mat-progress-bar>
                        <span class="progress-text">{{formatearPorcentaje(element.porcentajePagadoInquilino)}}</span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Columna Deuda Propietario -->
                  <ng-container matColumnDef="deudaPropietario">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-icon>payments</mat-icon>
                      Deuda Propietario
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="debt-info">
                        <span class="debt-amount pending">{{formatearMoneda(element.deudaPropietario)}}</span>
                        <span class="debt-periods">{{element.totalPeriodos - element.periodosLiquidadosPropietario}}
                          períodos</span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Columna % Liquidado Propietario -->
                  <ng-container matColumnDef="porcentajeLiquidadoPropietario">
                    <th mat-header-cell *matHeaderCellDef>
                      % Liquidado Propietario
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div class="progress-container">
                        <mat-progress-bar mode="determinate" [value]="element.porcentajeLiquidadoPropietario"
                          color="accent">
                        </mat-progress-bar>
                        <span
                          class="progress-text">{{formatearPorcentaje(element.porcentajeLiquidadoPropietario)}}</span>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    [class.inactive-contract]="!row.contratoActivo" (click)="trackByContrato(0, row)">
                  </tr>
                </table>

                <!-- Paginador -->
                <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25" showFirstLastButtons
                  [length]="dataSource.data.length">
                </mat-paginator>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="no-data-table" *ngIf="!reporteData">
    <span class="with-icon">
      <mat-icon>search_off</mat-icon>
      Configure los filtros y genere el reporte para visualizar los datos.
    </span>
  </div>
</div>
